/**
 * Check if the given element has been truncated by using text-overflow on it.
 * See https://stackoverflow.com/questions/7738117/html-text-overflow-ellipsis-detection for more information
 *
 * @param element Node to check
 */
export function isTruncated(element: HTMLElement) {
  return element.offsetWidth < element.scrollWidth;
}
